// LOP - Shared style swatch ordering (PLP + PDP)
(function () {
  'use strict';

  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  function buildSwatchStyle(bg) {
    if (!bg) return 'border: solid 1px #000;';
    if (bg.indexOf('background-color:') === 0 || bg.indexOf('url(') === 0) {
      return bg + ' border: solid 1px #000;';
    }
    return 'background-color: ' + bg + '; border: solid 1px #000;';
  }

  function parseSiblingsFromScript(script) {
    if (!script || !script.textContent) return [];

    try {
      var parsed = JSON.parse(script.textContent);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function sortSiblings(items) {
    var group = Array.isArray(items) ? items.slice() : [];
    var hasOrder = group.some(function (item) {
      return item && typeof item.sortIndex === 'number';
    });

    if (hasOrder) {
      return group.sort(function (a, b) {
        var ai = a && typeof a.sortIndex === 'number' ? a.sortIndex : 9999;
        var bi = b && typeof b.sortIndex === 'number' ? b.sortIndex : 9999;
        return ai - bi;
      });
    }

    return group.sort(function (a, b) {
      return String(a && a.handle).localeCompare(String(b && b.handle));
    });
  }

  function normalizeSiblingItem(item) {
    if (!item || !item.handle) return null;

    return {
      handle: item.handle,
      url: item.url || '',
      title: item.title || '',
      color: item.color || '',
      swatchBg: item.swatchBg || '',
      sortIndex: typeof item.sortIndex === 'number' ? item.sortIndex : undefined,
    };
  }

  window.LOPStyleSwatchOrder = {
    escapeHtml: escapeHtml,
    buildSwatchStyle: buildSwatchStyle,
    parseSiblingsFromScript: parseSiblingsFromScript,
    sortSiblings: sortSiblings,
    normalizeSiblingItem: normalizeSiblingItem,
  };
})();
